import React from 'react';
import Answers from './Answers';

class PrimaryStateAnswers extends React.Component {
    render() {
        return (
            <div className="primary-state-answers-wrapper">
                <Answers answers={this.props.answers} stateCode={this.props.stateCode} id={this.props.id} />
                </div>
        );
    }

}


export default PrimaryStateAnswers;


// WEBPACK FOOTER //
// ./src/components/PrimaryStateAnswers.js